import { legalCompanyDetails, tosDocument } from "@mealmanager/legal-content";
import type { Route } from "./+types/page";
import LegalDocumentPage from "../components/LegalDocumentPage";
import { buildSeoMeta } from "../utils/seo";

export const meta: Route.MetaFunction = ({ location }) =>
  buildSeoMeta({
    location,
    title: `${tosDocument.title} | ${legalCompanyDetails.brandName}`,
    description: `Read ${legalCompanyDetails.brandName}'s terms of service covering acceptable use, disclaimers, and access to the public site and companion apps.`,
    type: "article",
    modifiedTime: tosDocument.effectiveDate,
  });

export default function TermsOfServicePage() {
  return <LegalDocumentPage document={tosDocument} />;
}
